var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3168 3.84896L14.1835 3.84896C15.5085 3.84896 16.0418 4.34896 16.0418 5.61562L16.0418 15.5156L11.4585 15.5156L11.4585 5.61562C11.4585 4.34896 11.9918 3.84896 13.3168 3.84896Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23333 8.01562L7.1 8.01562C8.425 8.01562 8.95833 8.52396 8.95833 9.78229L8.95833 15.5156L4.375 15.5156L4.375 9.78229C4.375 8.52396 4.90833 8.01562 6.23333 8.01562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 15.5154C18.3332 15.8571 18.0498 16.1404 17.7082 16.1404L2.2915 16.1404C1.9415 16.1488 1.6665 15.8654 1.6665 15.5154C1.6665 15.1654 1.94984 14.8904 2.2915 14.8904L17.7082 14.8904C18.0498 14.8988 18.3332 15.1738 18.3332 15.5154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.4abcf2ff9831719af8b0453e04ccc03a.svg";
export { ForwardRef as ReactComponent };